import React from 'react';

export default function Loader({ text = 'Loading...' }) {
  return (
    <div className="page-loader">
      <div className="text-center">
        <div className="spinner-vz mx-auto mb-3"></div>
        <p className="text-muted small">{text}</p>
      </div>
    </div>
  );
}
